import React from 'react';
import { PollyEnv } from '../../types';

interface DevEnvToggleProps {
  value: PollyEnv;
  onChange: (env: PollyEnv) => void;
  disabled?: boolean;
}

const OPTIONS: { value: PollyEnv; label: string }[] = [
  { value: 'testpolly', label: 'Test' },
  { value: 'polly', label: 'Prod' },
];

export function DevEnvToggle({ value, onChange, disabled }: DevEnvToggleProps) {
  return (
    <div className="lp-dev-toggle" role="group" aria-label="Development environment selector">
      <span className="lp-dev-toggle__badge" aria-hidden="true">DEV</span>
      <span className="lp-dev-toggle__label">Environment</span>
      <div className="lp-dev-toggle__pills">
        {OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            className={`lp-dev-toggle__pill${value === opt.value ? ' lp-dev-toggle__pill--active' : ''}`}
            onClick={() => onChange(opt.value)}
            disabled={disabled}
            aria-pressed={value === opt.value}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
